// extracted by mini-css-extract-plugin
module.exports = {"main":"ordersPage_dealerSelect_main__3Z7F6","isDisabled":"ordersPage_dealerSelect_isDisabled__H5MM4"};